import { useState } from 'react'
import {Calculator, Percent, Tag} from 'lucide-react'
import CalculadoraAba from '@/components/CalculadoraAba'
import VendaAvulsa from '@/components/VendaAvulsa'

type SubAbaCalculadora = 'desconto' | 'cheio'

export default function AbaCalculadoraOleosEssenciais() {
  const [subAba, setSubAba] = useState<SubAbaCalculadora>('desconto')

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-cormorant font-semibold text-texto-escuro mb-1 flex items-center gap-2">
          <Calculator className="w-6 h-6 text-verde-escuro" />
          Calculadora de Óleos Essenciais
        </h2>
        <p className="text-sm text-texto-suave">
          Escolha o tipo de preço para montar o orçamento: com desconto de membro ou preço cheio de consumidor.
        </p>
      </div>

      <div
        className="flex flex-col sm:flex-row gap-2 p-1.5 rounded-2xl bg-white border"
        style={{ borderColor: '#EDE0D4' }}
        role="tablist"
        aria-label="Tipo de preço"
      >
        <button
          type="button"
          role="tab"
          aria-selected={subAba === 'desconto'}
          onClick={() => setSubAba('desconto')}
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all ${
            subAba === 'desconto'
              ? 'bg-[#2D6A4F] text-white shadow-sm'
              : 'text-[#5F5E5A] hover:bg-[#F8F4EF]'
          }`}
        >
          <Percent className="w-4 h-4" />
          Preço com Desconto
          <span className={subAba === 'desconto' ? 'text-white/80' : 'text-[#B08968]'}>
            (membro)
          </span>
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={subAba === 'cheio'}
          onClick={() => setSubAba('cheio')}
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all ${
            subAba === 'cheio'
              ? 'bg-[#2D6A4F] text-white shadow-sm'
              : 'text-[#5F5E5A] hover:bg-[#F8F4EF]'
          }`}
        >
          <Tag className="w-4 h-4" />
          Preço Cheio
          <span className={subAba === 'cheio' ? 'text-white/80' : 'text-[#B08968]'}>
            (consumidor)
          </span>
        </button>
      </div>

      {subAba === 'desconto' ? <CalculadoraAba /> : <VendaAvulsa />}
    </div>
  )
}
